// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/IntegrationRunDetail.yaml
// Generated: 2026-03-17T14:51:32.497Z
// </auto-generated>

import { ReadOnlyEntityService } from '@/lib/EntityService';
import { IntegrationRunDetail } from '@/types/integration/IntegrationRunDetail';

/**
 * IntegrationRunDetail Service (Read-Only)
 * Query operations for IntegrationRunDetail via the ABP API.
 */
export const integrationRunDetailService = new ReadOnlyEntityService<IntegrationRunDetail>(
  '/api/integration/integrationrundetail',
  'IntegrationRunDetail',
);
